import { GetWorkAreaMapsDocument, GetWorkAreaMapsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkAreaMapNodes = NonNullable<
  GetWorkAreaMapsQuery['spaceControl']['workAreaMapsConnection']['nodes']
>[0]

export type WorkAreaMapsById = Record<string, WorkAreaMapNodes>

interface UseWorkAreaMapsProps {
  workAreaIds: string[]
  skip?: boolean
}

export const useWorkAreaMaps = ({ workAreaIds, skip }: UseWorkAreaMapsProps) => {
  const { data, loading, error } = useQuery(GetWorkAreaMapsDocument, {
    variables: {
      workAreaIds,
    },
    skip: skip || workAreaIds.length === 0,
  })

  const workAreaMaps = data?.spaceControl?.workAreaMapsConnection?.nodes || []

  const workAreaMapsById: WorkAreaMapsById = {}
  workAreaMaps.forEach((map) => {
    if (map?.workAreaId) {
      workAreaMapsById[map.workAreaId] = map
    }
  })

  return {
    workAreaMapsById,
    loading,
    error,
  }
}
